import Vue from 'vue';
import VueMq from 'vue-mq';

import Filters from '@js/filters';
import Post from './components/Post';
import { breakpoints } from '@js/constants/constants';

Vue.component('Post', Post);
Vue.use(Filters);
Vue.use(VueMq, {
  breakpoints,
  defaultBreakpoint: 'xs'
});

new Vue({
  el: '.post',
  data() {
    return {
      loading: false
    }
  }
});
